import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./profile.css";

const Profile = () => {
  const navigate = useNavigate();

  const [isEdit, setIsEdit] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const [profile, setProfile] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    gender: "",
    dob: "",
    tob: "",
    birthPlace: "",
    address: "",
    cityStateCountry: "",
    pincode: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      const user = JSON.parse(localStorage.getItem("user") || "null");

      if (!isLoggedIn || !user?.id) {
        navigate("/login");
        return;
      }

      try {
        const res = await fetch(
          "https://dashboard.jyotirvani.com/api/customer-profile",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ customer_id: user.id }),
          }
        );

        const data = await res.json();

        if (data.status && data.data) {
          const freshUser = data.data;
          localStorage.setItem("user", JSON.stringify(freshUser));

          setProfile({
            firstName: freshUser?.name || freshUser?.first_name || "",
            lastName: freshUser?.last_name || "",
            phone: freshUser?.phone || "",
            gender: freshUser?.gender || "",
            dob: freshUser?.dob || "",
            tob: freshUser?.tob || "",
            birthPlace: freshUser?.birth_place || "",
            address: freshUser?.address || "",
            cityStateCountry: freshUser?.city_state_country || "",
            pincode: freshUser?.pincode || "",
          });
        }
      } catch (error) {
        console.error("Profile fetch error:", error);
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let finalValue = value;

    if (name === "phone") finalValue = value.replace(/\D/g, "").slice(0, 10);
    if (name === "pincode") finalValue = value.replace(/\D/g, "").slice(0, 6);

    setProfile((prev) => ({
      ...prev,
      [name]: finalValue,
    }));
  };

  const handleUpdateProfile = async () => {
    const user = JSON.parse(localStorage.getItem("user") || "null");

    if (!user?.id) {
      alert("User id not found. Please login again.");
      navigate("/login");
      return;
    }

    if (!profile.firstName.trim()) {
      alert("First name is required");
      return;
    }

    if (profile.phone && profile.phone.length !== 10) {
      alert("Phone number must be 10 digits");
      return;
    }

    if (profile.pincode && profile.pincode.length !== 6) {
      alert("Pincode must be 6 digits");
      return;
    }

    try {
      setIsUpdating(true);

      const res = await fetch(
        "https://dashboard.jyotirvani.com/api/update-profile",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            customer_id: user.id,
            first_name: profile.firstName,
            last_name: profile.lastName,
            phone: profile.phone,
            gender: profile.gender,
            dob: profile.dob,
            tob: profile.tob,
            birth_place: profile.birthPlace,
            address: profile.address,
            city_state_country: profile.cityStateCountry,
            pincode: profile.pincode,
          }),
        }
      );

      const data = await res.json();

      if (data.status) {
        const updatedUser = data.data || {
          ...user,
          first_name: profile.firstName,
          last_name: profile.lastName,
          name: profile.firstName,
          phone: profile.phone,
          gender: profile.gender,
          dob: profile.dob,
          tob: profile.tob,
          birth_place: profile.birthPlace,
          address: profile.address,
          city_state_country: profile.cityStateCountry,
          pincode: profile.pincode,
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
        window.dispatchEvent(new Event("loginUpdated"));

        alert("Profile updated successfully");
        setIsEdit(false);
      } else {
        alert(data.message || "Profile update failed");
      }
    } catch (err) {
      console.error("Update profile error:", err);
      alert("Update failed");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("user");
    window.dispatchEvent(new Event("loginUpdated"));
    navigate("/");
  };

  return (
    <div className="profile-page">
      <div className="profile-shell">
        <div className="profile-left-card">
          <div className="profile-brand-badge">JyotirVani</div>

          <div className="profile-avatar-card">
            <div className="profile-avatar">
              <i className="fa-solid fa-user"></i>
            </div>

            <h2>
              {profile.firstName || "User"} {profile.lastName}
            </h2>

            <p>{profile.phone || "Complete your profile details"}</p>
          </div>

          <div className="profile-side-info">
            <div>
              <span>Birth Place</span>
              <strong>{profile.birthPlace || "Not added"}</strong>
            </div>

            <div>
              <span>City / State</span>
              <strong>{profile.cityStateCountry || "Not added"}</strong>
            </div>
          </div>

          <div className="profile-buttons">
            

            <button type="button" className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>

        <div className="profile-right-card">
          <div className="profile-heading">
            <div>
              <h1>Profile Details</h1>
              <p>Manage your personal and astrology birth details.</p>
            </div>
             <div className="profile-buttons">
            <button type="button" onClick={() => setIsEdit(!isEdit)}>
              {isEdit ? "Cancel Edit" : "Edit Profile"}
            </button>
            </div>
          </div>

          <div className="profile-form">
            <InputBox label="First Name" name="firstName" value={profile.firstName} onChange={handleChange} disabled={!isEdit} />
            <InputBox label="Last Name" name="lastName" value={profile.lastName} onChange={handleChange} disabled={!isEdit} />

            <div className="form-group">
              <label>Gender</label>
              <select name="gender" value={profile.gender} onChange={handleChange} disabled={!isEdit}>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <InputBox label="Date of Birth" type="date" name="dob" value={profile.dob} onChange={handleChange} disabled={!isEdit} />
            <InputBox label="Time of Birth" type="time" name="tob" value={profile.tob} onChange={handleChange} disabled={!isEdit} />
            <InputBox label="Place of Birth" name="birthPlace" value={profile.birthPlace} onChange={handleChange} disabled={!isEdit} />
            <InputBox label="Current Address" name="address" value={profile.address} onChange={handleChange} disabled={!isEdit} />
            <InputBox label="City, State, Country" name="cityStateCountry" value={profile.cityStateCountry} onChange={handleChange} disabled={!isEdit} />
            <InputBox label="Pincode" name="pincode" value={profile.pincode} onChange={handleChange} disabled={!isEdit} maxLength="6" />
            <InputBox label="Phone" name="phone" value={profile.phone} onChange={handleChange} disabled={!isEdit} maxLength="10" />
          </div>

          {isEdit && (
            <div className="update-area">
              <button type="button" onClick={handleUpdateProfile} disabled={isUpdating}>
                {isUpdating ? "Updating..." : "Update Profile"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const InputBox = ({ label, type = "text", name, value, onChange, disabled, maxLength }) => (
  <div className="form-group">
    <label>{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      maxLength={maxLength}
      placeholder={`Enter ${label.toLowerCase()}`}
    />
  </div>
);

export default Profile;